<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="cabinas"
        class="elevation-1"
        v-if="verNuevo == 0 && false"
        no-data-text="No hay datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Guardia</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-card flat tile width="200">
              <v-select
                :items="itemsGuardia"
                v-model="itemGuardia"
                hide-details
                label="Seleccione..."
              >
              </v-select>
            </v-card>
            <v-spacer></v-spacer>
            <v-card flat tile>
              Desde:
              <v-text-field
                hide-details
                type="date"
                v-model="fechaInicio"
              ></v-text-field>
            </v-card>
            <v-card flat tile class="ml-3">
              Hasta:
              <v-text-field
                hide-details
                type="date"
                v-model="fechaFin"
              ></v-text-field>
            </v-card>
            <v-spacer></v-spacer>
            <v-btn
              @click="listar()"
              color="green"
              v-if="verDet == 0"
              class="ml-auto"
              dark
              >Consultar y descargar</v-btn
            >
          </v-toolbar>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <template>
        <v-toolbar elevation="1" color="white">
          <v-toolbar-title>Guardia</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-card flat tile width="200">
            <v-select
              :items="itemsGuardia"
              v-model="itemGuardia"
              hide-details
              label="Tipo guardia"
            >
            </v-select>
          </v-card>
          <v-spacer></v-spacer>
          <v-card flat tile>
            Desde:
            <v-text-field
              hide-details
              type="date"
              v-model="fechaInicio"
            ></v-text-field>
          </v-card>
          <v-card flat tile class="ml-3">
            Hasta:
            <v-text-field
              hide-details
              type="date"
              v-model="fechaFin"
            ></v-text-field>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn
            @click="listar()"
            color="green"
            v-if="verDet == 0"
            class="ml-auto"
            dark
            >Consultar y descargar</v-btn
          >
        </v-toolbar>
      </template>

      <template>
        <v-card class="mx-auto mt-5" max-width="500">
          <v-card-title
            >Seleccione tipo de guardia e intervalo de fechas</v-card-title
          >
          <v-card-text class="title text-center">
            <p>
              Presione el botón de 'Consultar y descargar' y automáticamente le
              descargara un archivo Excel.
            </p>
          </v-card-text>
        </v-card>
      </template>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackValidacion" color="cyan darken-2" right top
        >Los campos de Fecha y datos no deben de estar vacias.</v-snackbar
      >
      <v-snackbar v-model="snackValidacionExcel" color="cyan darken-2" right top
        >No hay datos que descargar.</v-snackbar
      >
      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="placa" label="Placa"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="polizaBase" label="Poliza"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="marcaBase" label="Marca"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="modeloBase" label="Modelo"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="añoBase" label="Año" readonly></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="titularPolizaBase"
              label="Ttular Poliza"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg4 x14>
            <v-autocomplete
              v-model="cartera"
              :items="list_cartera"
              label="Cartera"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="color" label="Color" readonly></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="nombreConductor"
              label="Nombre conductor"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete v-model="pais" :items="list_pais" label="Pais">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="depaSiniestro"
              :items="list_depaSiniestro"
              label="Departamento Siniestro"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="muniSiniestro"
              :items="list_muniSiniestro"
              label="Municipio Siniestro"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-textarea
              v-model="comDireccionSiniestro"
              label="Complemento Direccion Siniestro"
              auto-grow
              outlined
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="tipoAsistencia"
              :items="list_tipoAsistencia"
              label="Tipo De Asistencia"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="placaContraparte"
              label="Placa Contraparte"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-textarea
              v-model="obsAdicionales"
              label="Observaciones Adicionales"
              auto-grow
              outlined
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="localForaneo"
              :items="list_localForaneo"
              label="Local/Foraneo"
            ></v-autocomplete>
          </v-flex>
          <v-checkbox
            class="mx-2"
            v-model="partePolicial"
            label="Hay Parte Policial?"
          ></v-checkbox>
          <v-checkbox
            class="mx-2"
            v-model="pasaFiscalia"
            label="Pasa a fiscalia"
          ></v-checkbox>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="responsable"
              label="Responsable"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-spacer></v-spacer>
            <v-btn @click="ocultarNuevo()" color="cancel">Cancelar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
var moment = require("moment");
import settings from "../settings/index";
export default {
  data() {
    return {
      cabinas: [],
      itemsGuardia: ["General", "ASSA", "Legal"],
      itemGuardia: "",
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
        },
        { text: "Fecha Actual", value: "fechaHoraActual", sortable: true },
        { text: "Placa", value: "placa", sortable: true },
        { text: "Poliza", value: "polizaBase", sortable: true },
        { text: "Marca", value: "marcaBase", sortable: true },
        { text: "Modelo", value: "modeloBase", sortable: true },
        { text: "Año", value: "añoBase", sortable: true },
        { text: "Titular Poliza", value: "titularPolizaBase", sortable: true },
      ],
      fechaInicio: "",
      fechaFin: "",
      id: "",
      idBase: "",
      cartera: "",
      list_cartera: [],
      numeroAsistencia: "",
      placa: "",
      polizaBase: "",
      marcaBase: "",
      modeloBase: "",
      añoBase: 0,
      titularPolizaBase: "",
      color: "",
      nombreConductor: "",
      pais: "",
      list_pais: settings.list_pais,
      depaSiniestro: "",
      list_depaSiniestro: settings.list_depaSiniestro,
      muniSiniestro: "",
      list_muniSiniestro: settings.list_muniSiniestro,
      placaContraparte: "",
      partePolicial: false,
      pasaFiscalia: false,
      obsAdicionales: "",
      responsable: "",
      tipoAsistencia: "",
      list_tipoAsistencia: [],
      localForaneo: "",
      list_localForaneo: settings.list_localForaneo,
      verNuevo: 0,
      verDet: 0,
      validaMensaje: "",
      overlay: false,
      snackValidacion: false,
      snackValidacionExcel: false,
      field_fechaActual: [],
      fechas: { fecha: "" },
      horas: { hora: "" },
      exportData: [],
    };
  },
  created() {
    this.listarCarteras();
    this.listarTipoAsistencias();
    if (this.$store.state.usuario.rol == "Inspector") {
      this.itemsGuardia = ["ASSA"];
    }
    if (
      this.$store.state.usuario.nombre == "REGIONAL TWO" ||
      this.$store.state.usuario.nombre == "REGIONAL THREE"
    ) {
      this.itemsGuardia = ["General"];
    }
  },
  methods: {
    listarTipoAsistencias() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias/Activas", configuracion)
        .then((res) => (this.list_tipoAsistencia = res.data))
        .catch((err) => console.error(err.response));
    },
    listarCarteras() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.list_cartera = res.data))
        .catch((err) => console.error(err.response));
    },
    mostrarNuevo() {
      let me = this;
      this.verNuevo = 1;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    listar() {
      let me = this;
      me.cabinas = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let url = "";
      if (
        me.fechaInicio != "" &&
        me.fechaFin != "" &&
        me.itemGuardia == "Futuro"
      ) {
        me.overlay = true;
        url = "api/Cabinas/GuardiaFuturo/" + me.fechaInicio + "/" + me.fechaFin;
        axios
          .get(url, configuracion)
          .then(function (response) {
            me.cabinas = response.data;
            me.overlay = false;
            me.guardiaFuturoProgramado();
          })
          .catch(function (error) {
            console.log(error);
            me.overlay = false;
          });
      } else if (
        me.fechaInicio != "" &&
        me.fechaFin != "" &&
        me.itemGuardia == "General"
      ) {
        me.overlay = true;
        url =
          "api/Cabinas/GuardiaGeneral/" + me.fechaInicio + "/" + me.fechaFin;
        axios
          .get(url, configuracion)
          .then(function (response) {
            me.cabinas = response.data;
            me.overlay = false;
            me.guardiaGeneralProgramado();
          })
          .catch(function (error) {
            console.log(error);
            me.overlay = false;
          });
      } else if (
        me.fechaInicio != "" &&
        me.fechaFin != "" &&
        me.itemGuardia == "ASSA"
      ) {
        me.overlay = true;
        url = "api/Cabinas/GuardiaAssa/" + me.fechaInicio + "/" + me.fechaFin;
        axios
          .get(url, configuracion)
          .then(function (response) {
            me.cabinas = response.data;
            me.overlay = false;
            me.guardiaAssaProgramado();
          })
          .catch(function (error) {
            console.log(error);
            me.overlay = false;
          });
      } else if (
        me.fechaInicio != "" &&
        me.fechaFin != "" &&
        me.itemGuardia == "Legal"
      ) {
        me.overlay = true;
        url = "api/Cabinas/GuardiaLegal/" + me.fechaInicio + "/" + me.fechaFin;
        axios
          .get(url, configuracion)
          .then(function (response) {
            me.cabinas = response.data;
            me.overlay = false;
            me.ExportarExcel();
          })
          .catch(function (error) {
            console.log(error);
            me.overlay = false;
          });
      } else {
        me.snackValidacion = true;
      }
    },
    guardiaFuturoProgramado() {
      let me = this;
      me.exportData = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/GuardiaFuturoProgramado/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].fechaHoraActual != null) {
              var fechaActual_list =
                response.data[i].fechaHoraActual.split("T");
              var fechaActual = moment(fechaActual_list[0]).format(
                "DD/MM/YYYY"
              );
              var horaActual = fechaActual_list[1];
            }
            if (response.data[i].fechaHoraCierreAsistencia != null) {
              var fechaCierre_list =
                response.data[i].fechaHoraActual.split("T");
              var fechaCierre = moment(fechaActual_list[0]).format(
                "DD/MM/YYYY"
              );
              var horaCierre = fechaCierre_list[1];
            }
            me.exportData.push({
              "NUMERO DE ASISTENCIA": response.data[i].numeroAsistencia,
              CARTERA: response.data[i].cartera,
              FECHA: fechaActual,
              HORA: horaActual,
              PLACA: response.data[i].placa,
              POLIZA: response.data[i].polizaBase,
              MARCA: response.data[i].marcaBase,
              MODELO: response.data[i].modeloBase,
              AÑO: response.data[i].añoBase,
              COLOR: response.data[i].color,
              CONDUCTOR: response.data[i].nombreConductor,
              TITULAR: response.data[i].titularPolizaBase,
              PAIS: response.data[i].pais,
              DEPARTAMENTO: response.data[i].depaSiniestro,
              MUNICIPIO: response.data[i].muniSiniestro,
              DIRECCION: response.data[i].comDireccionSiniestro,
              SERVICIO: response.data[i].tipoAsistencia,
              TERCERO: response.data[i].placaContraparte,
              "PARTE POLICIAL": response.data[i].partePolicial,
              OBSERVACIONES: response.data[i].obsAdicionales,
              LOCALIDAD: response.data[i].localForaneo,
              "FECHA CIERRE": fechaCierre,
              "HORA CIERRE": horaCierre,
              TELEFONO: response.data[i].numeroTelefono,
              FISCALIA: response.data[i].pasaFiscalia,
              RESPONSABLE: response.data[i].responsable,
            });
          }
          me.ExportarExcel();
        })
        .catch(function (error) {
          console.log(error);
          me.overlay = false;
        });
    },
    guardiaGeneralProgramado() {
      let me = this;
      me.exportData = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/GuardiaGeneralProgramado/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].fechaHoraActual != null) {
              var fechaActual_list =
                response.data[i].fechaHoraActual.split("T");
              var fechaActual = moment(fechaActual_list[0]).format(
                "DD/MM/YYYY"
              );
              var horaActual = fechaActual_list[1];
            }
            if (response.data[i].fechaHoraCierreAsistencia != null) {
              var fechaCierre_list =
                response.data[i].fechaHoraActual.split("T");
              var fechaCierre = moment(fechaActual_list[0]).format(
                "DD/MM/YYYY"
              );
              var horaCierre = fechaCierre_list[1];
            }
            if (me.$store.state.usuario.rol == "Inspector") {
              if (
                response.data[i].proveedor.proveedor ==
                me.$store.state.usuario.nombre
              ) {
                me.exportData.push({
                  "NUMERO DE ASISTENCIA": response.data[i].numeroAsistencia,
                  CARTERA: response.data[i].cartera,
                  FECHA: fechaActual,
                  HORA: horaActual,
                  PLACA: response.data[i].placa,
                  POLIZA: response.data[i].polizaBase,
                  MARCA: response.data[i].marcaBase,
                  MODELO: response.data[i].modeloBase,
                  AÑO: response.data[i].añoBase,
                  COLOR: response.data[i].color,
                  CONDUCTOR: response.data[i].nombreConductor,
                  TITULAR: response.data[i].titularPolizaBase,
                  PAIS: response.data[i].pais,
                  DEPARTAMENTO: response.data[i].depaSiniestro,
                  MUNICIPIO: response.data[i].muniSiniestro,
                  DIRECCION: response.data[i].comDireccionSiniestro,
                  SERVICIO: response.data[i].tipoAsistencia,
                  TERCERO: response.data[i].placaContraparte,
                  "PARTE POLICIAL": response.data[i].partePolicial,
                  OBSERVACIONES: response.data[i].obsAdicionales,
                  LOCALIDAD: response.data[i].localForaneo,
                  "FECHA CIERRE": fechaCierre,
                  "HORA CIERRE": horaCierre,
                  TELEFONO: response.data[i].numeroTelefono,
                  FISCALIA: response.data[i].pasaFiscalia,
                  RESPONSABLE: response.data[i].responsable,
                });
              }
            } else {
              console.log("else no es inspector");
              me.exportData.push({
                "NUMERO DE ASISTENCIA": response.data[i].numeroAsistencia,
                CARTERA: response.data[i].cartera,
                FECHA: fechaActual,
                HORA: horaActual,
                PLACA: response.data[i].placa,
                POLIZA: response.data[i].polizaBase,
                MARCA: response.data[i].marcaBase,
                MODELO: response.data[i].modeloBase,
                AÑO: response.data[i].añoBase,
                COLOR: response.data[i].color,
                CONDUCTOR: response.data[i].nombreConductor,
                TITULAR: response.data[i].titularPolizaBase,
                PAIS: response.data[i].pais,
                DEPARTAMENTO: response.data[i].depaSiniestro,
                MUNICIPIO: response.data[i].muniSiniestro,
                DIRECCION: response.data[i].comDireccionSiniestro,
                SERVICIO: response.data[i].tipoAsistencia,
                TERCERO: response.data[i].placaContraparte,
                "PARTE POLICIAL": response.data[i].partePolicial,
                OBSERVACIONES: response.data[i].obsAdicionales,
                LOCALIDAD: response.data[i].localForaneo,
                "FECHA CIERRE": fechaCierre,
                "HORA CIERRE": horaCierre,
                TELEFONO: response.data[i].numeroTelefono,
                FISCALIA: response.data[i].pasaFiscalia,
                RESPONSABLE: response.data[i].responsable,
              });
            }
          }
          me.ExportarExcel();
        })
        .catch(function (error) {
          console.log(error);
          me.overlay = false;
        });
    },
    guardiaAssaProgramado() {
      let me = this;
      let arrayFechaHoraActual = [];
      let arrayFechaHoraContacto = [];
      let arrayFechaHoraCierre = [];
      let arrayFechaHoraAsignacion = [];
      let proveedorDeServicios = "PROVEEDOR DE SERVICIOS";
      me.exportData = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/GuardiaAssaProgramado/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            var stringFechaAtual = response.data[i].fechaHoraActual;
            var stringFechaContacto = response.data[i].fechaHoraContacto;
            var stringFechaAsignacion = response.data[i].fechaHoraAsignacion;
            if (stringFechaAsignacion != null) {
              arrayFechaHoraAsignacion = stringFechaAsignacion.split("T");
              var fechaAsignacion = moment(arrayFechaHoraAsignacion[0]).format(
                "DD/MM/YYYY"
              );
            } else {
              arrayFechaHoraAsignacion[0] = "";
              arrayFechaHoraAsignacion[1] = "";
            }
            if (stringFechaAtual != null) {
              arrayFechaHoraActual = stringFechaAtual.split("T");
            } else {
              arrayFechaHoraActual[0] = "";
              arrayFechaHoraActual[1] = "";
            }
            if (stringFechaContacto != null) {
              arrayFechaHoraContacto = stringFechaContacto.split("T");
              var fechaContacto = moment(arrayFechaHoraContacto[0]).format(
                "DD/MM/YYYY"
              );
            } else {
              arrayFechaHoraContacto[0] = "";
              arrayFechaHoraContacto[1] = "";
            }
            if (arrayFechaHoraActual[0] != "") {
              var fechaActual = moment(arrayFechaHoraActual[0]).format(
                "DD/MM/YYYY"
              );
            } else {
              fechaActual = "";
            }
            if (
              me.cabinas[i].proveedor == "DAVID MOZ" ||
              me.cabinas[i].proveedor == "CHRISTIAN HERNANDEZ"
            ) {
              proveedorDeServicios = me.cabinas[i].proveedor;
            }
            me.exportData.push({
              No: i + 1,
              "EXPEDIENTE AR": response.data[i].numeroAsistencia,
              "EXPEDIENTE ASSA": response.data[i].expedienteAssa,
              "TIPO DE SERVICIO": response.data[i].tipoAsistencia,
              PROVEEDOR: proveedorDeServicios,
              FECHA: fechaActual,
              "HORA DE LLAMADA": arrayFechaHoraActual[1],
              "FECHA ASIGNACION": fechaAsignacion,
              "HORA ASIGNACION": arrayFechaHoraAsignacion[1],
              "FECHA CONTACTO": fechaContacto,
              "HORA CONTACTO": arrayFechaHoraContacto[1],
              POLIZA: response.data[i].poliza,
              CONDUCTOR: response.data[i].nombreConductor,
              ASEGURADO: response.data[i].titularpoliza,
              PLACA: response.data[i].placa,
              DEPARTAMENTO: response.data[i].depaSiniestro,
              DIRECCIÓN: response.data[i].comDireccionSiniestro,
              RECOBRO: response.data[i].cantRecupero,
              "INSPECCIÓN IN SITU O VIRTUAL":
                response.data[i].inspeccionInSituVirtual,
              "RAPIASSA ASEGURADO": me.cabinas[i].rapiAssaAsegurado,
              "RAPIASSA TERCERO": me.cabinas[i].rapiAssaTercero,
              "MOTIVO NO USO RAPIASSA": me.cabinas[i].motivoNoUsoRapiassa,
              "USÓ GRÚA ASEGURADO": me.cabinas[i].usoGruaAsegurado,
              "USÓ GRÚA TERCERO": me.cabinas[i].usoGruaTercero,
              "TALLER ASEGURADO": me.cabinas[i].tallerAsegurado,
              "TALLER TERCERO": me.cabinas[i].tallerTercero,
              "ESTADO VIRTUAL": response.data[i].estadoVirtual,
              OBSERVACIONES: response.data[i].obsAdicionales,
              LOCALIDAD: response.data[i].localForaneo,
              "CANAL DE SOLICITUD": response.data[i].metodoSolicitudAsistencia,
            });
            proveedorDeServicios = "PROVEEDOR DE SERVICIOS";
          }
          me.ExportarExcel();
        })
        .catch(function (error) {
          console.log(error);
          me.overlay = false;
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.id = item.idCabina;
      this.cartera = item.cartera;
      this.placa = item.placa;
      this.polizaBase = item.polizaBase;
      this.marcaBase = item.marcaBase;
      this.modeloBase = item.modeloBase;
      this.añoBase = item.añoBase;
      this.titularPolizaBase = item.titularPolizaBase;
      this.color = item.color;
      this.nombreConductor = item.nombreConductor;
      this.pais = item.pais;
      this.depaSiniestro = item.depaSiniestro;
      this.list_muniSiniestro[0] = item.muniSiniestro;
      this.muniSiniestro = this.list_muniSiniestro[0];
      this.comDireccionSiniestro = item.comDireccionSiniestro;
      this.placaContraparte = item.placaContraparte;
      this.partePolicial = item.partePolicial;
      this.obsAdicionales = item.obsAdicionales;
      this.tipoAsistencia = item.tipoAsistencia;
      this.localForaneo = item.localForaneo;
      this.pasaFiscalia = item.pasaFiscalia;
      this.responsable = item.responsable;
      this.verNuevo = 1;
      this.verDet = 1;
    },
    limpiar() {
      this.id = "";
      this.cartera = "";
      this.placa = "";
      this.polizaBase = "";
      this.modeloBase = "";
      this.marcaBase = "";
      this.añoBase = 0;
      this.titularPolizaBase = "";
      this.nombreConductor = "";
      this.pais = "";
      this.depaSiniestro = "";
      this.muniSiniestro = "";
      this.comDireccionSiniestro = "";
      this.placaContraparte = "";
      this.partePolicial = "";
      this.obsAdicionales = "";
      this.tipoAsistencia = "";
      this.localForaneo = "";
      this.operador = "";
      this.pasaFiscalia = "";
      this.responsable = "";
      this.verDet = 0;
      this.exportData = [];
    },
    detallesGuardiaAssa() {
      let me = this;
      let arrayFechaHoraActual = [];
      let arrayFechaHoraContacto = [];
      let arrayFechaHoraCierre = [];
      let arrayFechaHoraAsignacion = [];
      let proveedorDeServicios = "PROVEEDOR DE SERVICIOS";
      for (var i = 0; i < me.cabinas.length; i++) {
        var stringFechaAtual = me.cabinas[i].fechaHoraActual;
        var stringFechaContacto = me.cabinas[i].fechaHoraContacto;
        var stringFechaAsignacion = me.cabinas[i].fechaHoraAsignacion;
        if (stringFechaAsignacion != null) {
          arrayFechaHoraAsignacion = stringFechaAsignacion.split("T");
          var fechaAsignacion = moment(arrayFechaHoraAsignacion[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          arrayFechaHoraAsignacion[0] = "";
          arrayFechaHoraAsignacion[1] = "";
        }
        if (stringFechaAtual != null) {
          arrayFechaHoraActual = stringFechaAtual.split("T");
        } else {
          arrayFechaHoraActual[0] = "";
          arrayFechaHoraActual[1] = "";
        }
        if (stringFechaContacto != null) {
          arrayFechaHoraContacto = stringFechaContacto.split("T");
          var fechaContacto = moment(arrayFechaHoraContacto[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          arrayFechaHoraContacto[0] = "";
          arrayFechaHoraContacto[1] = "";
        }
        if (arrayFechaHoraActual[0] != "") {
          var fechaActual = moment(arrayFechaHoraActual[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          fechaActual = "";
        }
        let flag = false;
        me.exportData.map(function (x) {
          if (x["EXPEDIENTE AR"] == me.cabinas[i].numeroAsistencia) {
            flag = true;
          }
        });
        if (flag == false) {
          //validacion para que no agrege estas asistencias con nombre de proveedor excedente
          if (me.cabinas[i].proveedor != "EXCEDENTE") {
            if (
              me.cabinas[i].proveedor == "DAVID MOZ" ||
              me.cabinas[i].proveedor == "CHRISTIAN HERNANDEZ"
            ) {
              proveedorDeServicios = me.cabinas[i].proveedor;
            }
            if (this.$store.state.usuario.rol == "Inspector") {
              if (this.$store.state.usuario.nombre == me.cabinas[i].proveedor) {
                me.exportData.push({
                  No: i + 1,
                  "EXPEDIENTE AR": me.cabinas[i].numeroAsistencia,
                  "EXPEDIENTE ASSA": me.cabinas[i].expedienteAssa,
                  "TIPO DE SERVICIO": me.cabinas[i].tipoAsistencia,
                  PROVEEDOR: proveedorDeServicios,
                  FECHA: fechaActual,
                  "HORA DE LLAMADA": arrayFechaHoraActual[1],
                  "FECHA ASIGNACION": fechaAsignacion,
                  "HORA ASIGNACION": arrayFechaHoraAsignacion[1],
                  "FECHA CONTACTO": fechaContacto,
                  "HORA CONTACTO": arrayFechaHoraContacto[1],
                  POLIZA: me.cabinas[i].poliza,
                  CONDUCTOR: me.cabinas[i].nombreConductor,
                  ASEGURADO: me.cabinas[i].titularpoliza,
                  PLACA: me.cabinas[i].placa,
                  DEPARTAMENTO: me.cabinas[i].depaSiniestro,
                  DIRECCIÓN: me.cabinas[i].comDireccionSiniestro,
                  RECOBRO: me.cabinas[i].cantRecupero,
                  "INSPECCIÓN IN SITU O VIRTUAL":
                    me.cabinas[i].inspeccionInSituVirtual,
                  "RAPIASSA ASEGURADO": me.cabinas[i].rapiAssaAsegurado,
                  "RAPIASSA TERCERO": me.cabinas[i].rapiAssaTercero,
                  "MOTIVO NO USO RAPIASSA": me.cabinas[i].motivoNoUsoRapiassa,
                  "USÓ GRÚA ASEGURADO": me.cabinas[i].usoGruaAsegurado,
                  "USÓ GRÚA TERCERO": me.cabinas[i].usoGruaTercero,
                  "TALLER ASEGURADO": me.cabinas[i].tallerAsegurado,
                  "TALLER TERCERO": me.cabinas[i].tallerTercero,
                  "ESTADO VIRTUAL": me.cabinas[i].estadoVirtual,
                  OBSERVACIONES: me.cabinas[i].obsAdicionales,
                  LOCALIDAD: me.cabinas[i].localForaneo,
                  "CANAL DE SOLICITUD": me.cabinas[i].metodoSolicitudAsistencia,
                });
                proveedorDeServicios = "PROVEEDOR DE SERVICIOS";
              }
            } else {
              me.exportData.push({
                No: i + 1,
                "EXPEDIENTE AR": me.cabinas[i].numeroAsistencia,
                "EXPEDIENTE ASSA": me.cabinas[i].expedienteAssa,
                "TIPO DE SERVICIO": me.cabinas[i].tipoAsistencia,
                PROVEEDOR: proveedorDeServicios,
                FECHA: fechaActual,
                "HORA DE LLAMADA": arrayFechaHoraActual[1],
                "FECHA ASIGNACION": fechaAsignacion,
                "HORA ASIGNACION": arrayFechaHoraAsignacion[1],
                "FECHA CONTACTO": fechaContacto,
                "HORA CONTACTO": arrayFechaHoraContacto[1],
                POLIZA: me.cabinas[i].poliza,
                CONDUCTOR: me.cabinas[i].nombreConductor,
                ASEGURADO: me.cabinas[i].titularpoliza,
                PLACA: me.cabinas[i].placa,
                DEPARTAMENTO: me.cabinas[i].depaSiniestro,
                DIRECCIÓN: me.cabinas[i].comDireccionSiniestro,
                RECOBRO: me.cabinas[i].cantRecupero,
                "INSPECCIÓN IN SITU O VIRTUAL":
                  me.cabinas[i].inspeccionInSituVirtual,
                "RAPIASSA ASEGURADO": me.cabinas[i].rapiAssaAsegurado,
                "RAPIASSA TERCERO": me.cabinas[i].rapiAssaTercero,
                "MOTIVO NO USO RAPIASSA": me.cabinas[i].motivoNoUsoRapiassa,
                "USÓ GRÚA ASEGURADO": me.cabinas[i].usoGruaAsegurado,
                "USÓ GRÚA TERCERO": me.cabinas[i].usoGruaTercero,
                "TALLER ASEGURADO": me.cabinas[i].tallerAsegurado,
                "TALLER TERCERO": me.cabinas[i].tallerTercero,
                "ESTADO VIRTUAL": me.cabinas[i].estadoVirtual,
                OBSERVACIONES: me.cabinas[i].obsAdicionales,
                LOCALIDAD: me.cabinas[i].localForaneo,
                "CANAL DE SOLICITUD": me.cabinas[i].metodoSolicitudAsistencia,
              });
              proveedorDeServicios = "PROVEEDOR DE SERVICIOS";
            }
          }
        }
      }
    },
    detallesGuardiaGeneralFuturo() {
      let me = this;
      let arrayFechaHoraActual = [];
      let arrayFechaHoraContacto = [];
      let arrayFechaHoraCierre = [];
      let arrayFechaHoraAsignacion = [];
      for (var i = 0; i < me.cabinas.length; i++) {
        var stringFechaAtual = me.cabinas[i].fechaHoraActual;
        var stringFechaCierre = me.cabinas[i].fechaHoraCierreAsistencia;
        if (stringFechaAtual != null) {
          arrayFechaHoraActual = stringFechaAtual.split("T");
        } else {
          arrayFechaHoraActual[0] = "";
          arrayFechaHoraActual[1] = "";
        }
        if (stringFechaCierre != null) {
          arrayFechaHoraCierre = stringFechaCierre.split("T");
        } else {
          arrayFechaHoraCierre[0] = "";
          arrayFechaHoraCierre[1] = "";
        }
        if (arrayFechaHoraActual[0] != "") {
          var fechaActual = moment(arrayFechaHoraActual[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          fechaActual = "";
        }
        if (arrayFechaHoraCierre[0] != "") {
          var fechaCierre = moment(arrayFechaHoraCierre[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          fechaCierre = "";
        }
        var horaActual = arrayFechaHoraActual[1];
        var horaCierre = arrayFechaHoraCierre[1];
        let flag = false;
        me.exportData.map(function (x) {
          if (x["NUMERO DE ASISTENCIA"] == me.cabinas[i].numeroAsistencia) {
            flag = true;
          }
        });
        if (flag == false) {
          if (this.$store.state.usuario.rol == "Inspector") {
            if (me.cabinas[i].proveedor == this.$store.state.usuario.nombre) {
              if (
                me.cabinas[i].proveedor == "REGIONAL TWO" ||
                me.cabinas[i].proveedor == "REGIONAL THREE"
              ) {
                me.exportData.push({
                  "NUMERO DE ASISTENCIA": me.cabinas[i].numeroAsistencia,
                  CARTERA: me.cabinas[i].cartera,
                  FECHA: fechaActual,
                  HORA: horaActual,
                  PLACA: me.cabinas[i].placa,
                  POLIZA: me.cabinas[i].polizaBase,
                  MARCA: me.cabinas[i].marcaBase,
                  MODELO: me.cabinas[i].modeloBase,
                  AÑO: me.cabinas[i].añoBase,
                  COLOR: me.cabinas[i].color,
                  CONDUCTOR: me.cabinas[i].nombreConductor,
                  TITULAR: me.cabinas[i].titularPolizaBase,
                  PAIS: me.cabinas[i].pais,
                  DEPARTAMENTO: me.cabinas[i].depaSiniestro,
                  MUNICIPIO: me.cabinas[i].muniSiniestro,
                  DIRECCION: me.cabinas[i].comDireccionSiniestro,
                  SERVICIO: me.cabinas[i].tipoAsistencia,
                  TERCERO: me.cabinas[i].placaContraparte,
                  "PARTE POLICIAL": me.cabinas[i].partePolicial,
                  OBSERVACIONES: me.cabinas[i].obsAdicionales,
                  LOCALIDAD: me.cabinas[i].localForaneo,
                  "FECHA CIERRE": fechaCierre,
                  "HORA CIERRE": horaCierre,
                  TELEFONO: me.cabinas[i].numeroTelefono,
                  FISCALIA: me.cabinas[i].pasaFiscalia,
                  RESPONSABLE: me.cabinas[i].responsable,
                  COSTO: me.cabinas[i].costoServicio,
                });
              } else {
                me.exportData.push({
                  "NUMERO DE ASISTENCIA": me.cabinas[i].numeroAsistencia,
                  CARTERA: me.cabinas[i].cartera,
                  FECHA: fechaActual,
                  HORA: horaActual,
                  PLACA: me.cabinas[i].placa,
                  POLIZA: me.cabinas[i].polizaBase,
                  MARCA: me.cabinas[i].marcaBase,
                  MODELO: me.cabinas[i].modeloBase,
                  AÑO: me.cabinas[i].añoBase,
                  COLOR: me.cabinas[i].color,
                  CONDUCTOR: me.cabinas[i].nombreConductor,
                  TITULAR: me.cabinas[i].titularPolizaBase,
                  PAIS: me.cabinas[i].pais,
                  DEPARTAMENTO: me.cabinas[i].depaSiniestro,
                  MUNICIPIO: me.cabinas[i].muniSiniestro,
                  DIRECCION: me.cabinas[i].comDireccionSiniestro,
                  SERVICIO: me.cabinas[i].tipoAsistencia,
                  TERCERO: me.cabinas[i].placaContraparte,
                  "PARTE POLICIAL": me.cabinas[i].partePolicial,
                  OBSERVACIONES: me.cabinas[i].obsAdicionales,
                  LOCALIDAD: me.cabinas[i].localForaneo,
                  "FECHA CIERRE": fechaCierre,
                  "HORA CIERRE": horaCierre,
                  TELEFONO: me.cabinas[i].numeroTelefono,
                  FISCALIA: me.cabinas[i].pasaFiscalia,
                  RESPONSABLE: me.cabinas[i].responsable,
                });
              }
            }
          } else {
            me.exportData.push({
              "NUMERO DE ASISTENCIA": me.cabinas[i].numeroAsistencia,
              CARTERA: me.cabinas[i].cartera,
              FECHA: fechaActual,
              HORA: horaActual,
              PLACA: me.cabinas[i].placa,
              POLIZA: me.cabinas[i].polizaBase,
              MARCA: me.cabinas[i].marcaBase,
              MODELO: me.cabinas[i].modeloBase,
              AÑO: me.cabinas[i].añoBase,
              COLOR: me.cabinas[i].color,
              CONDUCTOR: me.cabinas[i].nombreConductor,
              TITULAR: me.cabinas[i].titularPolizaBase,
              PAIS: me.cabinas[i].pais,
              DEPARTAMENTO: me.cabinas[i].depaSiniestro,
              MUNICIPIO: me.cabinas[i].muniSiniestro,
              DIRECCION: me.cabinas[i].comDireccionSiniestro,
              SERVICIO: me.cabinas[i].tipoAsistencia,
              TERCERO: me.cabinas[i].placaContraparte,
              "PARTE POLICIAL": me.cabinas[i].partePolicial,
              OBSERVACIONES: me.cabinas[i].obsAdicionales,
              LOCALIDAD: me.cabinas[i].localForaneo,
              "FECHA CIERRE": fechaCierre,
              "HORA CIERRE": horaCierre,
              TELEFONO: me.cabinas[i].numeroTelefono,
              FISCALIA: me.cabinas[i].pasaFiscalia,
              RESPONSABLE: me.cabinas[i].responsable,
            });
          }
        }
      }
    },
    detallesGuardiaLegal() {
      let me = this;
      let arrayFechaHoraActual = [];
      let arrayFechaHoraContacto = [];
      let arrayFechaHoraCierre = [];
      let arrayFechaHoraAsignacion = [];
      for (var i = 0; i < me.cabinas.length; i++) {
        var stringFechaAtual = me.cabinas[i].fechaHoraActual;
        var stringFechaCierre = me.cabinas[i].fechaHoraCierreAsistencia;
        if (stringFechaAtual != null) {
          arrayFechaHoraActual = stringFechaAtual.split("T");
        } else {
          arrayFechaHoraActual[0] = "";
          arrayFechaHoraActual[1] = "";
        }
        if (stringFechaCierre != null) {
          arrayFechaHoraCierre = stringFechaCierre.split("T");
        } else {
          arrayFechaHoraCierre[0] = "";
          arrayFechaHoraCierre[1] = "";
        }
        if (arrayFechaHoraActual[0] != "") {
          var fechaActual = moment(arrayFechaHoraActual[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          fechaActual = "";
        }
        if (arrayFechaHoraCierre[0] != "") {
          var fechaCierre = moment(arrayFechaHoraCierre[0]).format(
            "DD/MM/YYYY"
          );
        } else {
          fechaCierre = "";
        }
        var horaActual = arrayFechaHoraActual[1];
        var horaCierre = arrayFechaHoraCierre[1];
        me.exportData.push({
          "NUMERO DE ASISTENCIA": me.cabinas[i].numeroAsistencia,
          CARTERA: me.cabinas[i].cartera,
          FECHA: fechaActual,
          HORA: horaActual,
          PLACA: me.cabinas[i].placa,
          POLIZA: me.cabinas[i].polizaBase,
          MARCA: me.cabinas[i].marcaBase,
          MODELO: me.cabinas[i].modeloBase,
          AÑO: me.cabinas[i].añoBase,
          COLOR: me.cabinas[i].color,
          CONDUCTOR: me.cabinas[i].nombreConductor,
          TITULAR: me.cabinas[i].titularPolizaBase,
          PAIS: me.cabinas[i].pais,
          DEPARTAMENTO: me.cabinas[i].depaSiniestro,
          MUNICIPIO: me.cabinas[i].muniSiniestro,
          DIRECCION: me.cabinas[i].comDireccionSiniestro,
          SERVICIO: me.cabinas[i].tipoAsistencia,
          PROVEEDOR: me.cabinas[i].proveedor,
          TERCERO: me.cabinas[i].placaContraparte,
          "PARTE POLICIAL": me.cabinas[i].partePolicial,
          OBSERVACIONES: me.cabinas[i].obsAdicionales,
          LOCALIDAD: me.cabinas[i].localForaneo,
          "FECHA CIERRE": fechaCierre,
          "HORA CIERRE": horaCierre,
          TELEFONO: me.cabinas[i].numeroTelefono,
          FISCALIA: me.cabinas[i].pasaFiscalia,
          RESPONSABLE: me.cabinas[i].responsable,
          "ESTATUS ASISTENCIA": me.cabinas[i].estatusAsistencia,
        });
      }
    },
    ExportarExcel() {
      let me = this;
      switch (me.itemGuardia) {
        case "ASSA":
          me.detallesGuardiaAssa();
          break;
        case "General":
        case "Futuro":
          me.detallesGuardiaGeneralFuturo();
          break;
        case "Legal":
          me.detallesGuardiaLegal();
          break;
      }
      let data = XLSX.utils.json_to_sheet(me.exportData);
      const workbook = XLSX.utils.book_new();
      const filename = "Guardia " + me.fechaInicio + " " + me.fechaFin;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
      me.limpiar();
    },
  },
};
</script>